var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/IDVerificationConstants.js').ActionTypes;
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var DigitalConsentConstants = require('../constants/DigitalConsentConstants.js');
var NetCodeAPI = require('../apis/NetCodeAPI.js');
var ClientsAPI = require('../apis/ClientsAPI.js');

module.exports = {
    removeIDVerificationForm: function (id, investorId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REMOVE_IDVERIFICATION_DOCUMENT,
            id: id,
            investorId: investorId
        });
    },

    changeIDVerificationType: function (docId, investorId, docTypeKey) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CHANGE_IDVERIFICATION_DOCUMENT,
            docId: docId,
            investorId: investorId,
            docTypeKey: docTypeKey
        });
    },

    updateIDVerificationForm: function (docId, investorId, formInputValue, formInputName) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_IDVERIFICATION_DOCUMENT,
            docId: docId,
            investorId: investorId,
            formInputValue: formInputValue,
            formInputName: formInputName
        });
    },

    startEditIDVerificationForm: function(docId, investorId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.START_EDIT_IDVERIFICATION_DOCUMENT,
            docId: docId,
            investorId: investorId
        });
    },

    cancelEditIDVerificationForm: function (docId, investorId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CANCEL_EDIT_IDVERIFICATION_DOCUMENT,
            docId: docId,
            investorId: investorId
        });
    },

    finishEditIDVerificationForm: function (docId, investorId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FINISH_EDIT_IDVERIFICATION_DOCUMENT,
            docId: docId,
            investorId: investorId
        });
    },

    getFieldValidations: function (investorId, id) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GET_FORM_FIELD_VALIDATIONS,
            investorId: investorId,
            id: id
        });
    },

    checkDigitalConsentEligibility: function () {
        NetCodeAPI.getUserIp();
        AppDispatcher.dispatch({
            actionType: ActionTypes.CHECK_DIGITAL_CONSENT_ELIGIBILITY
        });
    },

    updateNetCodeModel:function(value, fieldId, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_NETCODE_MODEL,
            value: value,
            fieldId: fieldId,
            index: index
        });
    },

    navigateToNetCodeEntryPage: function (productId, mobileNumbers, applicationId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GO_TO_NETCODE_ENTRY_PAGE
        });
        if (mobileNumbers.length === 1) {
            NetCodeAPI.generateSingleNetCode(productId, mobileNumbers[0], applicationId);
        } else {
            NetCodeAPI.generateMultipleNetCodes(productId, mobileNumbers, applicationId);
        }
    },

    submitNetCodes: function (productId, mobileNumbers, netCodes, applicationId, applicantCount) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SUBMIT_NETCODE
        });
        if (applicantCount === 1) {
            NetCodeAPI.verifySingleNetCode(productId, mobileNumbers[0], netCodes[0], applicationId);
        } else {
            NetCodeAPI.verifyMultipleNetCodes(productId, mobileNumbers, netCodes, applicationId);
        }
    },

    validateNetCode: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_NETCODE
        });
    },

    resendNetCode: function (productId, mobileNumbers, isJoint, applicationId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESEND_NETCODE
        });
        if (mobileNumbers.length === 1 && !isJoint) {
            NetCodeAPI.generateSingleNetCode(productId, mobileNumbers[0], applicationId);
        } else {
            NetCodeAPI.resendMultipleNetCodes(productId, mobileNumbers, applicationId);
        }
    },

    navigateToElectronicSubmissionPage: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GO_TO_ELECTRONIC_SUBMISSION_PAGE
        });
    },

    navigateToCongratulations: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GO_TO_CONGRATULATIONS
        });
    },

    updateWorkItemModel: function (workItem) {
        AppDispatcher.dispatch({
            actionType: ApplicationConstants.ActionTypes.UPDATE_WORKITEM,
            workItem: workItem
        });
    },

    declarationDisagreed: function () {
        AppDispatcher.dispatch({
            actionType: ApplicationConstants.ActionTypes.DECLARATION_DISAGREED
        });
    },
    verifyMobileNumbers: function (request) {
        ClientsAPI.verifyMobileNumber(request);
        AppDispatcher.dispatch({
            actionType: DigitalConsentConstants.ActionTypes.VERIFY_MOBILE_NUMBERS
        });
    },
    sendDigitalConsent: function (result, timeStamp) {
        AppDispatcher.dispatch({
            actionType: DigitalConsentConstants.ActionTypes.SEND_DIGITAL_CONSENT,
            result: result,
            timeStamp: timeStamp
        });
        
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/IDVerificationActions.js